/** Configuração da skill SDR (espelha defaults do backend sdrSkill.js). */

import {
  VALIDACAO_RESPOSTA_NONE,
  VALIDACAO_RESPOSTA_NUMERO_RANGE,
  normalizeOptionalNumber,
  normalizeValidacaoResposta,
} from "./chatbotSlotInputValidation";

export {
  VALIDACAO_RESPOSTA_NONE,
  VALIDACAO_RESPOSTA_NUMERO_RANGE,
  VALIDACAO_RESPOSTA_TYPES,
  VALIDACAO_RESPOSTA_LABEL_KEYS,
  normalizeValidacaoResposta,
} from "./chatbotSlotInputValidation";

export const DEFAULT_SDR_FIELDS = [
  {
    key: "empresa",
    label: "Empresa",
    question: "Para eu entender melhor, qual é o nome da empresa?",
    required: true,
    weight: 20,
    validacao_resposta: VALIDACAO_RESPOSTA_NONE,
  },
  {
    key: "desafio",
    label: "Principal desafio",
    question: "Qual é o principal desafio que vocês querem resolver agora?",
    required: true,
    weight: 30,
    validacao_resposta: VALIDACAO_RESPOSTA_NONE,
  },
  {
    key: "prazo",
    label: "Prazo",
    question: "Existe algum prazo ou prioridade para resolver isso?",
    required: true,
    weight: 20,
    validacao_resposta: VALIDACAO_RESPOSTA_NONE,
  },
  {
    key: "decisor",
    label: "Decisor",
    question: "Você participa da decisão ou existe outra pessoa que também precisa avaliar?",
    required: false,
    weight: 15,
    validacao_resposta: VALIDACAO_RESPOSTA_NONE,
  },
  {
    key: "orcamento",
    label: "Orçamento",
    question: "Vocês já têm uma faixa de orçamento ou investimento previsto?",
    required: false,
    weight: 15,
    validacao_resposta: VALIDACAO_RESPOSTA_NONE,
  },
];

export const SDR_PRESET_METHODS = ["BANT", "SPIN", "GPCT", "MEDDIC"];

export const SDR_DEFAULT_MESSAGES = {
  intro_message:
    "Olá! Sou o SDR virtual da equipe. Vou fazer algumas perguntas rápidas para entender se conseguimos ajudar e, se fizer sentido, já posso sugerir horários com um vendedor.",
  qualified_message:
    "Pelo que você compartilhou, faz sentido avançarmos para uma conversa com um especialista.",
  disqualified_message:
    "Obrigado pelas informações. Neste momento talvez não sejamos o melhor próximo passo, mas posso encaminhar seu contexto para a equipe avaliar.",
  no_slots_message:
    "Você parece aderente ao que atendemos, mas não encontrei horários livres na agenda configurada agora. Vou encaminhar para a equipe seguir com você.",
  email_question: "Para enviar o convite da reunião, qual e-mail posso usar?",
};

export function parsePositiveIdList(value) {
  const raw = Array.isArray(value)
    ? value
    : value == null || value === ""
      ? []
      : String(value).split(/[,\s;]+/);
  return [...new Set(raw.map(Number).filter((n) => Number.isFinite(n) && n > 0).map(Math.trunc))];
}

export function slugifySdrFieldKey(value, fallback = "campo") {
  const slug = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");
  return slug || fallback;
}

export function normalizeSdrFields(config) {
  const rows =
    Array.isArray(config?.qualification_fields) && config.qualification_fields.length
      ? config.qualification_fields
      : DEFAULT_SDR_FIELDS;
  return rows.map((row, idx) => {
    const defaults = DEFAULT_SDR_FIELDS[idx] || {};
    const validacao_resposta = normalizeValidacaoResposta(
      row?.validacao_resposta ?? row?.response_type ?? defaults.validacao_resposta ?? VALIDACAO_RESPOSTA_NONE
    );
    const numeroMin = normalizeOptionalNumber(row?.validacao_numero_min);
    const numeroMax = normalizeOptionalNumber(row?.validacao_numero_max);
    return {
      ...defaults,
      ...(row || {}),
      key: slugifySdrFieldKey(row?.key || defaults.key || `campo_${idx + 1}`, `campo_${idx + 1}`),
      label: row?.label || defaults.label || `Campo ${idx + 1}`,
      question: row?.question || defaults.question || "",
      required: row?.required !== false,
      weight: Number(row?.weight ?? defaults.weight ?? 10) || 0,
      validacao_resposta,
      validacao_numero_min: validacao_resposta === VALIDACAO_RESPOSTA_NUMERO_RANGE ? numeroMin : null,
      validacao_numero_max: validacao_resposta === VALIDACAO_RESPOSTA_NUMERO_RANGE ? numeroMax : null,
    };
  });
}

export function sdrFieldsTotalWeight(fields) {
  return (fields || []).reduce((sum, field) => sum + (Number(field.weight) || 0), 0);
}

export function userDisplayLabel(user) {
  if (!user) return "";
  return String(user.nome || user.name || user.email || `#${user.id || ""}`).trim();
}

export function calendarDisplayLabel(calendar, usersById = new Map()) {
  if (!calendar) return "";
  const owner = usersById.get(Number(calendar.ownerUserId));
  const rawOwner = userDisplayLabel(owner) || calendar.ownerName || "";
  const ownerName = calendar.ownerDeleted && rawOwner ? `${rawOwner} (excluído)` : rawOwner;
  const ownerSuffix = ownerName ? ` — ${ownerName}` : "";
  const typeSuffix = calendar.type ? ` (${calendar.type})` : "";
  return `${calendar.name || `#${calendar.id}`}${typeSuffix}${ownerSuffix}`;
}

export function resolveSdrQualificationMethod(method) {
  const value = String(method || "BANT").trim();
  if (!value) return { preset: "BANT", custom: "" };
  if (SDR_PRESET_METHODS.includes(value)) return { preset: value, custom: "" };
  return { preset: "custom", custom: value };
}
